import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UtilityService {
  private isChange = new BehaviorSubject(false);
  isChangeValue= this.isChange.asObservable();
  toggleIsChangealue(isChange: any) {
    this.isChange.next(isChange);
  }
}
